import { LoginInfoState } from '@/states/loginInfoState';
import { userState } from '@/states/selectors/userState';
import { checkIsLogin, validateRedirectUri } from '@/utils/common';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import url from '../../utils/config';

/**
 * 共通フッター。
 * 導線によってはヘッダーと同様に非表示にしつつ、未ログイン時のサポート導線を表示する。
 */
const Footer = () => {
  const router = useRouter();
  const [isLogin, setIsLogin] = useState(false);
  const user = useRecoilValue(userState);
  const loginInfo = useRecoilValue(LoginInfoState);

  useEffect(() => {
    // ページ種別ごとにフッター表示可否を切り替える。
    // 表示判定
    if (checkIsLogin(router.pathname)) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }

    // 戸建プランでメールアドレスの登録がない場合は、メールアドレス登録画面でヘッダフッタを表示しない
    // リダイレクト先URLが設定されている場合は、ヘッダフッタを表示しない
    const validatedRedirectUri = validateRedirectUri(router.asPath);
    if (
      router.pathname.startsWith('/contract/mail') &&
      ((user.isNuro && !loginInfo.is_verified_email) || validatedRedirectUri !== '')
    ) {
      setIsLogin(false);
    }

    // MNPワンストップ転出システムエラー画面に遷移する場合は、フッタを表示しない
    if (router.pathname.startsWith('/mobile/onestop/error')) {
      setIsLogin(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.pathname]);

  return (
    <footer className='l-footer'>
      {!isLogin && (
        <div className='l-footer__inner'>
          <div className='l-footer__nav'>
            <div style={{ marginBottom: '60px' }}>
              <ul className='c_footer__nav'>
                <li>
                  <a
                    className='l-footer__navLink'
                    href='https://www.nuro.jp/support/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    NURO 光 会員サポート
                  </a>
                </li>
                <li>
                  <a
                    className='l-footer__navLink'
                    href='https://www.nuro.jp/emerge/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    NURO障害・メンテナンス情報
                  </a>
                </li>
              </ul>
              <ul className='c_footer__nav'>
                <li>
                  <a
                    className='l-footer__navLink'
                    href='https://support.sonynetwork.co.jp/faqsupport/nuromobile/web/index.html'
                    target='_blank'
                    rel='noreferrer'
                  >
                    NUROモバイル 会員サポート
                  </a>
                </li>
                <li>
                  <a
                    className='l-footer__navLink'
                    href='https://www.sonynetwork.co.jp/corporation/safety/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    個人情報保護 / 情報セキュリティ
                  </a>
                </li>
                <li>
                  <a
                    className='l-footer__navLink'
                    href='https://www.nuro.jp/siteinfo/nuro/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    ウェブサイトご利用条件
                  </a>
                </li>
              </ul>
            </div>
            <p className='l-footer__navTxt'>
              NUROマイページでは、お客さまのご契約内容の確認や変更などのお手続きがおこなえます。
            </p>
          </div>
        </div>
      )}

      <div className='l-footer__copyArea'>
        <div className='l-footer__logo'>
          <a
            className='l-footer__logoLink'
            href='https://www.nuro.jp/brand/'
            target='_blank'
            rel='noreferrer'
          >
            <img
              className='l-footer__logoImg'
              src={url('/images/footer_logo-nuro.png')}
              alt='NURO'
            />
          </a>
        </div>
        <p className='l-footer__copy'>© Sony Network Communications Inc.</p>
      </div>
    </footer>
  );
};

export default Footer;
